// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .article-field-selector-dropdown-divider {
  margin: 0;
}
.presize-root .article-field-selector-dropdown-create-button {
  border: none;
  text-align: left;
}
/*# sourceMappingURL=ArticleFieldSelector.css.map */`, "",{"version":3,"sources":["webpack://./ArticleFieldSelector.less","webpack://./src/components/SelectionSidebar/ArticleFieldSelector.less"],"names":[],"mappings":"AAAA;EAEE,SAAA;ACAF;ADFA;EAME,YAAA;EACA,gBAAA;ACDF;AACA,mDAAmD","sourcesContent":[".presize-root { \n .article-field-selector-dropdown-divider {\n  margin: 0;\n}\n\n.article-field-selector-dropdown-create-button {\n  border: none;\n  text-align: left;\n}\n \n}",".presize-root .article-field-selector-dropdown-divider {\n  margin: 0;\n}\n.presize-root .article-field-selector-dropdown-create-button {\n  border: none;\n  text-align: left;\n}\n/*# sourceMappingURL=ArticleFieldSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
